import styled from 'styled-components'
import { rem } from 'polished'

export const OptionsMenuActions = styled.div`
  display: flex;
  flex-direction: column;
`

export const OptionsMenuButton = styled.button`
  background: none;
  border: none;
  padding: ${rem(8)} ${rem(16)};
  text-align: start;
  cursor: pointer;
  font-size: ${rem(14)};
  color: ${props => props.theme.palette.neutral.surface.normalContrast};

  &:hover {
    background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
  }
`
